import { render } from "./VTailwindModal.vue?vue&type=template&id=4d8d2e2e"
import script from "./VTailwindModal.vue?vue&type=script&lang=js"
export * from "./VTailwindModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__